
/**
 * A sortha String Is NOT null,empty or no string validation
 * @param inputValidation any
 * @returns True IF: a non empty("") string 
 */
export function ValidateStringInput(inputValidation: any): boolean {
    if (!inputValidation) {
        return false;
    }
    if (inputValidation === "") {
        return false;
    }
    if (!(typeof inputValidation === 'string' || inputValidation instanceof String)) {
        return false;
    }
    return true;
}